export default {
  sd_status: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  sd_status:[],
  selected_sd_status : {},
  sd_status_status:[]
}
